// ModalFormComanda.jsx
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment-timezone";
import { putComanda as modifComanda } from "../helpers/rutaComandas";
import { getEmpresas } from "../helpers/rutaEmpresas";
import { getTransportes } from "../helpers/rutaTransportes";
import { getChoferes } from "../helpers/rutaChoferes";
import { getClientes } from "../helpers/rutaClientes";
import { getDestinos } from "../helpers/rutaDestinos";
import { getProductos } from "../helpers/rutaProductos";
import { getCamiones } from "../helpers/rutaCamiones";
import { getEstados } from "../helpers/rutaEstados";
import "../css/modalformcomanda.css"; // agrega esta línea

// import "../css/addclienteform.css";
import 'animate.css';



const initialState = {
  codemp: "",
  nroviaje: "",
  fecha: "",
  codtra: "",
  codcho: "",
  codclif: "",
  factura: "",
  estado: "",
  tercero: "",
  codclic: "",
  codori: "",
  coddes: "",
  codclid: "",
  remitos: "",
  codpro: "",
  codcam: "",
  codest: "",
  kgsal: 0,
  kglle: 0,
  dif: 0,
  pactado: 0,
  subtotal: 0,
  porcentaje: "21", // "0" = Sin IVA, "10.5" o "21"
  iva: 0,
  total: 0,
  pactadoter: 0,
  kmsal: 0,
  kmdes: 0,
  observ: "",
};



export default function ModalFormComanda({ comanda, handleClose, show }) {

  const [showSuccess, setShowSuccess] = useState(false);

  const [form, setForm] = useState(initialState);
  const [lists, setLists] = useState({
    empresas: [], transportes: [], choferes: [],
    clientes: [], destinos: [], productos: [],
    camiones: [], estados: [], loading: true
  });


  // cargar catálogos
  useEffect(() => {
    Promise.all([
      getEmpresas(), getTransportes(), getChoferes(),
      getClientes(), getDestinos(), getProductos(),
      getCamiones(), getEstados()
    ]).then(([
      empRes, traRes, choRes, cliRes,
      desRes, proRes, camRes, estRes
    ]) => {
      setLists({
        empresas:    empRes.empresas    ?? empRes.data?.empresas    ?? [],
        transportes: traRes.transportes ?? traRes.data?.transportes ?? [],
        choferes:    choRes.choferes    ?? choRes.data?.choferes    ?? [],
        clientes:    cliRes.clientes    ?? cliRes.data?.clientes    ?? [],
        destinos:    desRes.destinos    ?? desRes.data?.destinos    ?? [],
        productos:   proRes.productos   ?? proRes.data?.productos   ?? [],
        camiones:    camRes.camiones    ?? camRes.data?.camiones    ?? [],
        estados:     estRes.estados     ?? estRes.data?.estados     ?? [],
        loading: false,
      });
    });
  }, []);

  // inicializar desde comanda
  useEffect(() => {
    if (comanda?._id) {
      setForm({
        ...initialState,
        codemp:     comanda.codemp?._id   || "",
        nroviaje:   comanda.nroviaje      || "",
        fecha:      comanda.fecha
                     ? moment(comanda.fecha).format("YYYY-MM-DDTHH:mm")
                     : "",
        codtra:     comanda.codtra?._id   || "",
        codcho:     comanda.codcho?._id   || "",
        codclif:    comanda.codclif?._id  || "",
        factura:    comanda.factura       || "",
        estado:     comanda.estado        || "",
        tercero:    comanda.tercero       || "",
        codclic:    comanda.codclic?._id  || "",
        codori:     comanda.codori?._id   || "",
        coddes:     comanda.coddes?._id   || "",
        codclid:    comanda.codclid?._id  || "",
        remitos:    comanda.remitos       || "",
        codpro:     comanda.codpro?._id   || "",
        codcam:     comanda.codcam?._id   || "",
        codest:     comanda.codest?._id   || "",
        kgsal:      comanda.kgsal         ?? 0,
        kglle:      comanda.kglle         ?? 0,
        pactado:    comanda.pactado       ?? 0,
        pactadoter: comanda.pactadoter    ?? 0,
        porcentaje:
          comanda.porcentaje !== undefined && comanda.porcentaje !== null
            ? String(comanda.porcentaje)
            : "21",
        kmsal:      comanda.kmsal         ?? 0,
        kmdes:      comanda.kmdes         ?? 0,
        observ:     comanda.observ        || "",
      });
    }
  }, [comanda]);

  // recalcular cálculos cuando kgsal, kglle o pactado cambian
  useEffect(() => {
    const kgsal   = parseFloat(form.kgsal)   || 0;
    const kglle   = parseFloat(form.kglle)   || 0;
    const pactado = parseFloat(form.pactado) || 0;
    const dif     = kgsal - kglle;
    const subtotal= kglle * pactado;
    const porcentajeNum = parseFloat(form.porcentaje || "21"); // 0 | 10.5 | 21
    const iva   = porcentajeNum === 0 ? 0 : subtotal * (porcentajeNum / 100);
    // const iva     = subtotal * 0.21;
    const total   = subtotal + iva;
    setForm(f => ({ ...f, dif, subtotal, iva, total }));
  }, [form.kgsal, form.kglle, form.pactado, form.porcentaje]);

  const handleChange = e => {
    const { name, value, type } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === "number" 
        ? parseFloat(value) || 0 
        : value
    }));
  };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   const payload = {
//     ...form,
//     fecha: new Date(form.fecha)
//   };

//   try {
//     const resp = await modifComanda(comanda._id, payload);
//     console.log("✅ Comanda actualizada:", resp);

//     setShowSuccess(true); // Mostrar el modal de éxito

//     setTimeout(() => {
//       setShowSuccess(false); // Ocultar mensaje
//       handleClose();         // Cerrar modal principal
//     }, 2000);
//   } catch (error) {
//     console.error("❌ Error al modificar comanda:", error);
//     // Acá podrías mostrar un modal de error si querés
//   }
// };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Preparamos el payload
  const payload = {
    ...form,
    fecha: new Date(form.fecha)
  };

  // Normalizá los campos que pueden ser "" pero en backend se espera null o un valor válido
  Object.keys(payload).forEach(key => {
    if (payload[key] === "") {
      payload[key] = null;
    }
  });

  try {
    const resp = await modifComanda(comanda._id, payload);
    console.log("✅ Comanda actualizada:", resp);

    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      handleClose();
    }, 2000);
  } catch (error) {
    console.error("❌ Error al modificar comanda:", error);
  }
};


  if (lists.loading) return <p>Cargando datos…</p>;

  return (
    <>
    <Modal show={show} onHide={handleClose} size="lg">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "bold", color: "red" }}>
            Editar Comanda Nro. {comanda.codcom} - Viaje {comanda.nroviaje}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Bloque general */}
          <div className="form-row">
            <div className="form-group col-md-3">
              <label>Empresa</label>
              <select
                name="codemp"
                className="form-control"
                value={form.codemp}
                onChange={handleChange}
                required
              >
                <option value="">Seleccione</option>
                {lists.empresas.map(e => (
                  <option key={e._id} value={e._id}>{e.empresa}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Nro Viaje</label>
              <input
                type="text"
                name="nroviaje"
                className="form-control"
                value={form.nroviaje}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-md-3">
              <label>Fecha</label>
              <input
                type="datetime-local"
                name="fecha"
                className="form-control"
                value={form.fecha}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-md-3">
              <label>Transporte</label>
              <select
                name="codtra"
                className="form-control"
                value={form.codtra}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.transportes.map(t => (
                  <option key={t._id} value={t._id}>{t.transporte}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Chofer / Cliente Factura / Estado / Tercero */}
          <div className="form-row">

            <div className="form-group col-md-3">
              <label>Chofer</label>
              <select
                name="codcho"
                className="form-control"
                value={form.codcho}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.choferes.map(c => (
                  <option key={c._id} value={c._id}>{c.nombre}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Cliente (Factura)</label>
              <select
                name="codclif"
                className="form-control"
                value={form.codclif}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.clientes.map(c => (
                  <option key={c._id} value={c._id}>{c.razonsocial}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Factura</label>
              <input
                type="text"
                name="factura"
                className="form-control"
                value={form.factura}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-3">
              <label>Estado</label>
              <input
                type="text"
                name="estado"
                className="form-control"
                value={form.estado}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-3">
              <label>Estado/Situacion</label>
              <select
                name="codest"
                className="form-control"
                value={form.codest}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.estados.map(e => (
                  <option key={e._id} value={e._id}>{e.estado}</option>
                ))}
              </select>
            </div>
         
            <div className="form-group col-md-3">
              <label>Tercero</label>
              <input
                type="text"
                name="tercero"
                className="form-control"
                value={form.tercero}
                onChange={handleChange}
              />
            </div>
           <div className="form-group col-md-3">
              <label>Cliente Carga</label>
              <select
                name="codclic"
                className="form-control"
                value={form.codclic}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.clientes.map(c => (
                  <option key={c._id} value={c._id}>{c.razonsocial}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Origen</label>
              <select
                name="codori"
                className="form-control"
                value={form.codori}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.destinos.map(d => (
                  <option key={d._id} value={d._id}>{d.destino}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Destino</label>
              <select
                name="coddes"
                className="form-control"
                value={form.coddes}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.destinos.map(d => (
                  <option key={d._id} value={d._id}>{d.destino}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Cliente Descarga</label>
              <select
                name="codclid"
                className="form-control"
                value={form.codclid}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.clientes.map(c => (
                  <option key={c._id} value={c._id}>{c.razonsocial}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Remitos</label>
              <input
                type="text"
                name="remitos"
                className="form-control"
                value={form.remitos}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-3">
              <label>Producto</label>
              <select
                name="codpro"
                className="form-control"
                value={form.codpro}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                {lists.productos.map(p => (
                  <option key={p._id} value={p._id}>{p.producto}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-2">
              <label>Kg Salida</label>
              <input
                type="number"
                name="kgsal"
                className="form-control"
                value={form.kgsal}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-2">
              <label>Kg Llegada</label>
              <input
                type="number"
                name="kglle"
                className="form-control"
                value={form.kglle}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-2">
              <label>Diferencia</label>
              <input
                type="number"
                name="dif"
                className="form-control"
                value={form.dif}
                readOnly
              />
            </div>
            <div className="form-group col-md-2">
              <label>Pactado</label>
              <input
                type="number"
                name="pactado"
                className="form-control"
                value={form.pactado}
                onChange={handleChange}
                // disabled
              />
            </div>
            <div className="form-group col-md-2">
              <label>Subtotal</label>
              <input
                type="number"
                name="subtotal"
                className="form-control"
                value={form.subtotal}
                readOnly
              />
            </div>
            <div className="form-group col-md-2">
              <label>Porc. IVA</label>
              <select
                name="porcentaje"
                className="form-control"
                value={form.porcentaje}
                onChange={handleChange}
              >
                <option value="0">Sin IVA (0%)</option>
                <option value="10.5">10,5%</option>
                <option value="21">21%</option>
              </select>
            </div>

            <div className="form-group col-md-2">
              <label>IVA</label>
              <input
                type="number"
                name="iva"
                className="form-control"
                value={form.iva}
                readOnly
              />
            </div>
            <div className="form-group col-md-2">
              <label>Total</label>
              <input
                type="number"
                name="total"
                className="form-control"
                value={form.total}
                readOnly
              />
            </div>
            <div className="form-group col-md-2">
              <label>Pactado Tercero</label>
              <input
                type="number"
                name="pactadoter"
                className="form-control"
                value={form.pactadoter}
                onChange={handleChange}
              />
            </div>

            <div className="form-group col-md-2">
              <label>Km Origen</label>
              <input
                type="number"
                name="kmsal"
                className="form-control"
                value={form.kmsal}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-2">
              <label>Km Destino</label>
              <input
                type="number"
                name="kmsdes"
                className="form-control"
                value={form.kmdes}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-12">
              <label>Observaciones</label>
              <input
                type="text"
                name="observ"
                className="form-control"
                value={form.observ}
                onChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
      
      
    </Modal>
    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
    >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
    </Modal>
    
    </>
  );
}
